<template>
  <div>
    <!-- Imagem overlay -->
    <v-overlay
      :value="isVisible"
      :absolute="isAbsolute"
      :opacity="opacity"
      :dark="dark"
      :cycle="cycle"
      :show-arrows="showArrows"
      :lista="imagesList"
      :especificacoes="especificacoes"
      :especificacoesParcial="especificacoesParcial"
      :item="item"
    >
      <v-card elevation="24" class="mx-auto align-content-center">
        <v-system-bar light
          >Item {{ item ? item.CODIGO : '' }} --
          {{ item ? item.DESCRICAO : '' }}</v-system-bar
        >
        <v-carousel
          :continuous="false"
          :cycle="cycle"
          :show-arrows="showArrows"
          hide-delimiter-background
          delimiter-icon="mdi-circle"
          height="450"
          show-arrows-on-hover
        >
          <v-carousel-item v-for="(image, i) in imagesList" :key="i">
            <v-sheet height="100%">
              <v-row
                class="fill-height rounded-lg mt-0"
                align="center"
                justify="center"
              >
                <v-img
                  class="display-3"
                  max-height="430"
                  :max-width="widthOverlay"
                  :min-width="widthOverlay"
                  min-height="430"
                  contain
                  :src="image"
                >
                </v-img>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        <v-list light :max-width="widthOverlay" max-height="82">
          <v-list-item dense>
            <v-list-item-content>
              <v-row no-gutters dense>
                <v-col cols="2" align-self="center">
                  <span>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          dark
                          color="info"
                          class="text-subtitle-2 ml-1 px-1 py-1"
                          @click="$emit('closeOverlay')"
                          v-on="on"
                          v-bind="attrs"
                          small
                        >
                          <v-icon small left>mdi-exit-to-app</v-icon>
                          <span class="text-overline">Voltar</span>
                        </v-btn>
                      </template>
                      <span>Voltar</span>
                    </v-tooltip>
                  </span>
                </v-col>
                <v-col cols="10">
                  <span>
                    {{ getEspecificacoesParcial(especificacoes) }}
                    <v-btn
                      v-if="especificacoes && especificacoes.length > 85"
                      @click="dialog = !dialog"
                      small
                      color="primary"
                      dark
                    >
                      Ver mais
                    </v-btn>
                  </span>
                </v-col>
              </v-row>
              <v-list-item-subtitle>
                <v-dialog width="500" v-model="dialog" scrollable>
                  <v-card>
                    <v-card-title class="mt-0 p-0" dark dense>
                      Especificações
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <span v-html="especificacoesComp"></span>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-on="on"
                            v-bind="attrs"
                            color="info"
                            small
                            dark
                            class="text-subtitle-2 ml-1 px-1 py-1"
                            @click="dialog = false"
                          >
                            <v-icon small left>mdi-exit-to-app</v-icon>
                            <span class="text-overline">Voltar</span>
                          </v-btn>
                        </template>
                        <span>Voltar para Imagem</span>
                      </v-tooltip>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      dialog: false,
    }
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    isAbsolute: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: true,
    },
    showArrows: {
      type: Boolean,
      default: true,
    },
    cycle: {
      type: Boolean,
      default: false,
    },
    opacity: {
      type: Number,
      default: 0.8,
    },
    imagesList: {
      type: Array,
      default: () => [],
    },
    especificacoesParcial: {
      type: String,
      default: '',
    },
    especificacoes: {
      type: String,
      default: '',
    },
    item: {
      type: [Object, String],
      default: () => {},
    },
  },
  computed: {
    especificacoesComp() {
      var re = /\r\n/gi
      return this.especificacoes
        ? this.especificacoes.replace(re, '<br>')
        : null
    },
    // Ver o breakpoint da página
    widthOverlay() {
      const size = {
        default: {
          xs: '600',
          sm: '600',
          md: '900',
          lg: '900',
          xl: '1200',
        },
      }
      let breakpointName = this.$vuetify.breakpoint.name
      return size.default[breakpointName] ?? 600
    },
    model: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('update:item', val)
      },
    },
  },
  methods: {
    getEspecificacoesParcial(especificacoes) {
      let especificacoesParcial = especificacoes
        ? especificacoes.substring(0, 85)
        : ''
      especificacoesParcial +=
        especificacoes && especificacoes.length > 85 ? '.....' : ''
      return especificacoesParcial
    },
  },
}
</script>
